ENUM_TYPE_DEFINITION